$(function() {
    //radio new window
    $(document).on('click', '.playRadio', function() {
        var playerUrl = this.href;
        var popupPlayer = window.open(playerUrl, 'RtvsRadioPlayer', 'width=320,height=675,scrollbars=no,resizable=no,status=no,menubar=no');
        return false;
    });

    //hide collapsed mobile nav when clicked outside of it
    $(document).on('click', function (e) {
        if ($('#navbarMobile').hasClass('show') && !$(e.target).closest('#navbarMobile').length) {
            $('#navbarMobile').collapse('hide');
        }
    })
  });